import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PropertySetService } from '../property-set.service';

@Component({
  selector: 'miq-confirmation-dialog',
  styleUrls: ['./property-set-confirmation-dialog.component.scss'],
  template: `
    <div class="dialog">
      <div class="fx--h fx--juc-space-between fx--ali-center dialog__header">
        <div mat-mdc-dialog-title>
          <h2>ALERT!</h2>
        </div>
        <mat-icon aria-hidden="false" aria-label="Close icon" (click)="onClose(false)">close</mat-icon>
      </div>

      <div mat-dialog-content>
        <div class="dialog__body">
          <div class="fx--h fx--ali-center fx--pb-20 message">
            <mat-icon class="mat-icon fx--ali-center" svgIcon="alert-icon"></mat-icon>
            <p>{{ message }}</p>
          </div>
        </div>
      </div>
      <div mat-dialog-actions>
        <div class="fx--h fx--juc-center fx--pt-20">
          <button mat-button color="primary" class="fx--mr-sm" (click)="onClose(false)">Cancel</button>
          <button mat-flat-button color="primary" (click)="deleteSelectedPropertySet()">Yes</button>
        </div>
      </div>
    </div>
  `,
  providers: [PropertySetService],
  standalone: false,
})
export class PropetySetConfirmationDialogComponent {
  public message: string;
  constructor(
    public dialogRef: MatDialogRef<PropetySetConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private dialogData: { propertySetId: number },
    private propertySetService: PropertySetService
  ) {
    this.message = 'Deleting a Property Set is permanent and cannot be undone. Are you sure you want to proceed?';
  }

  deleteSelectedPropertySet(): void {
    this.propertySetService.delete(this.dialogData.propertySetId).subscribe(() => {
      this.dialogRef.close(true);
    });
  }
  onClose(retry: boolean): void {
    this.dialogRef.close(retry);
  }
}
